export default __webpack_public_path__ + "static/media/github.03b9fe2f.svg";